import React from "react";

import { connectWithLifecycle } from "react-lifecycle-component";
import PendingOrderLines from "../container/PendingOrderLines2";
import { getFilteredOrdersMap } from "../../redux/selectors";

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
// injectTapEventPlugin();

const mapStateToProps = state => {
  const orders = getFilteredOrdersMap(state);
  return { orders: orders };
};

const mapDispatchToProps = dispatch => ({});

const listItemStyle = {
  float: "left",
  height: "1em",
  width: "1em",
  margin: "0 5px 0 0"
};

export const Producer = ({ orders }) => {
  return (
    <div>
      <PendingOrderLines orders={orders} />
      <p>Leyenda:</p>
      <ul>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "lightgrey" }} />
          Sin          empezar
        </li>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "orange" }} />
          En curso
        </li>
        <li style={{ listStyle: "none" }}>
          <span style={{ ...listItemStyle, backgroundColor: "lightgreen" }} />
          Hecho
        </li>
      </ul>
    </div>
  );
};

const ProducerPage = connectWithLifecycle(mapStateToProps, mapDispatchToProps)(
  Producer
);

export default ProducerPage;



// WEBPACK FOOTER //
// ./src/components/pages/Production.js